import ApplicationComponent from "legacy/ApplicationComponent"
import { badgeForInquiryStatus, humanize } from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class InquiryDetails extends ApplicationComponent {
  renderBoatDetailString() {
    const makeAndModel = [
      this.props.inquiry.boat.make,
      this.props.inquiry.boat.model,
    ].join(" ")
    const loaWithUnit = `${this.props.inquiry.boat.loa}'`
    const showMakeAndModel = makeAndModel.trim().length > 0
    return (
      <div>
        {showMakeAndModel && `${makeAndModel} • `}
        {loaWithUnit}
      </div>
    )
  }

  renderInquiryDates() {
    if (!!this.props.inquiry.startDate || !!this.props.inquiry.endDate) {
      return (
        <div className="flex flex-wrap gap-3">
          <div>
            <div className="font-bold">Start Date</div>
            <div className={this.props.inquiry.startDate ? "" : "text-center"}>
              {this.props.inquiry.startDate
                ? moment(this.props.inquiry.startDate).format("MM/DD/YYYY")
                : "-"}
            </div>
          </div>
          <div>
            <div className="font-bold">End Date</div>
            <div className={this.props.inquiry.endDate ? "" : "text-center"}>
              {this.props.inquiry.endDate
                ? moment(this.props.inquiry.endDate).format("MM/DD/YYYY")
                : "-"}
            </div>
          </div>
        </div>
      )
    }
    return null
  }

  render() {
    const borderClasses = this.props.embed
      ? "sm:border-0"
      : "sm:border-l sm:border-t-0 sm:pl-3"
    return (
      <div
        className={`inquiry-details-right w-full sm:w-2/5 ${borderClasses} flex flex-wrap gap-2 border-t`}
      >
        <div className="flex flex-wrap items-baseline gap-3">
          <div className="mr-4 mt-3 text-lg font-bold sm:mt-0">{`Inquiry #${this.props.inquiry.encodedId}`}</div>
          <div className="inquiry-detail-badges items-baseline">
            <div
              className={`badge ${badgeForInquiryStatus(
                this.props.inquiry.status
              )} mb-2 mr-2`}
            >
              {humanize(this.props.inquiry.status)}
            </div>
            <div className="badge badge-blue-inverted mb-2">
              {this.props.inquiry.category}
            </div>
          </div>
        </div>
        <div className="flex w-full gap-2 sm:flex-wrap">
          <div className="flex w-3/5 items-center rounded border border-gray-300 px-3 py-3 sm:w-full">
            <i className="fa-solid fa-ship mr-3 text-lg text-blue-600" />
            <div>
              <div className="font-bold">{this.props.inquiry.boat.name}</div>
              {this.renderBoatDetailString()}
            </div>
          </div>
          <div className="w-2/5 sm:w-full">{this.renderInquiryDates()}</div>
        </div>
      </div>
    )
  }
}

InquiryDetails.propTypes = {
  inquiry: PropTypes.shape({
    encodedId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    boat: PropTypes.shape({
      name: PropTypes.string.isRequired,
      make: PropTypes.string,
      model: PropTypes.string,
      loa: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
  embed: PropTypes.bool,
}

export default InquiryDetails
